// Guest Mode translations - Sign-up prompts and messaging
export const guestMode = {
  en: {
    // First quiz completion prompt (soft)
    saveProgressTitle: 'Want to save your progress?',
    saveProgressSubtitle: 'Sign up to track achievements, compete on leaderboards, and unlock all features',
    saveProgressBenefit1: 'Track your progress across all quizzes',
    saveProgressBenefit2: 'Compete on global leaderboards',
    saveProgressBenefit3: 'Unlock achievements and badges',
    saveProgressBenefit4: 'Play multiplayer with friends',
    signUpNow: 'Sign Up Now',
    maybeLater: 'Maybe Later',

    // Multiplayer gate (hard)
    multiplayerRequiredTitle: 'Sign in to join your family and friends',
    multiplayerRequiredSubtitle: 'Create an account to access multiplayer features',
    multiplayerRequiredMessage: 'Sign in to join your family or friends and keep your progress together.',
    backToSinglePlayer: 'Back to Single Player',

    // Live events gate (hard)
    liveEventsRequiredTitle: 'Sign in for Live Events',
    liveEventsRequiredSubtitle: 'Join live tournaments and compete in real-time',
    liveEventsRequiredMessage: 'Live events require an account to participate and track your rankings.',

    // Feature gate benefits section
    whatYouGet: 'What you\'ll get:',

    // Multiplayer feature benefits
    multiplayerFeature1: 'Play real-time quizzes with family and friends',
    multiplayerFeature2: 'Compete in private groups and track your rankings',
    multiplayerFeature3: 'Challenge others and grow in faith together',

    // Live events feature benefits
    liveEventsFeature1: 'Join global tournaments and win prizes',
    liveEventsFeature2: 'Compete with thousands of players worldwide',
    liveEventsFeature3: 'Track your live rankings and achievements',

    // Feature gate actions
    signUpButton: 'Create Free Account',
    goBack: 'Not Now',
    guestProgressNotice: 'Your guest progress will be saved when you sign up!',

    // After 3rd quiz (gamification)
    streakTitle: 'You\'re on a roll! 🔥',
    streakSubtitle: 'Sign up now to start your quiz streak and never lose your progress',
    streakProgress: '{count} quizzes completed',
    streakBenefit: 'Keep your {count}-quiz streak going!',

    // Achievement prompt (after quiz 3 with new timing)
    achievementTitle: 'Great Progress!',
    achievementSubtitle: 'Sign up to save your achievements and continue your journey',

    // Progressive engagement benefits
    benefit1: 'Track your quiz history and progress',
    benefit2: 'Compete on leaderboards with others',
    benefit3: 'Earn achievements and badges',
    benefit4: 'Play multiplayer with friends and family',
    whySignUp: 'Why sign up?',
    continuePlaying: 'Continue Playing',

    // Data migration messaging
    migratingProgress: 'Saving your progress...',
    progressSaved: 'Your progress has been saved!',
    progressMigrationError: 'Could not save guest progress',

    // Guest mode indicators
    guestBadge: 'Guest',
    signInToSave: 'Sign in to save',
    limitedFeatures: 'Limited Features',
  },
  es: {
    saveProgressTitle: '¿Quieres guardar tu progreso?',
    saveProgressSubtitle: 'Regístrate para seguir logros, competir en tablas de clasificación y desbloquear todas las funciones',
    saveProgressBenefit1: 'Rastrea tu progreso en todos los cuestionarios',
    saveProgressBenefit2: 'Compite en tablas de clasificación globales',
    saveProgressBenefit3: 'Desbloquea logros e insignias',
    saveProgressBenefit4: 'Juega multijugador con amigos',
    signUpNow: 'Registrarse Ahora',
    maybeLater: 'Quizás Más Tarde',

    multiplayerRequiredTitle: 'Inicia sesión para unirte a tu familia y amigos',
    multiplayerRequiredSubtitle: 'Crea una cuenta para acceder a funciones multijugador',
    multiplayerRequiredMessage: 'Inicia sesión para unirte a tu familia o amigos y mantener tu progreso junto.',
    backToSinglePlayer: 'Volver a Un Jugador',

    liveEventsRequiredTitle: 'Inicia sesión para Eventos en Vivo',
    liveEventsRequiredSubtitle: 'Únete a torneos en vivo y compite en tiempo real',
    liveEventsRequiredMessage: 'Los eventos en vivo requieren una cuenta para participar y seguir tus clasificaciones.',

    whatYouGet: 'Lo que obtendrás:',

    multiplayerFeature1: 'Juega cuestionarios en tiempo real con familia y amigos',
    multiplayerFeature2: 'Compite en grupos privados y rastrea tus clasificaciones',
    multiplayerFeature3: 'Desafía a otros y crece en fe juntos',

    liveEventsFeature1: 'Únete a torneos globales y gana premios',
    liveEventsFeature2: 'Compite con miles de jugadores en todo el mundo',
    liveEventsFeature3: 'Rastrea tus clasificaciones y logros en vivo',

    signUpButton: 'Crear Cuenta Gratis',
    goBack: 'Ahora No',
    guestProgressNotice: '¡Tu progreso de invitado se guardará cuando te registres!',

    streakTitle: '¡Estás en racha! 🔥',
    streakSubtitle: 'Regístrate ahora para iniciar tu racha de cuestionarios y nunca perder tu progreso',
    streakProgress: '{count} cuestionarios completados',
    streakBenefit: '¡Mantén tu racha de {count} cuestionarios!',

    achievementTitle: '¡Gran Progreso!',
    achievementSubtitle: 'Regístrate para guardar tus logros y continuar tu viaje',

    benefit1: 'Rastrea tu historial y progreso de cuestionarios',
    benefit2: 'Compite en tablas de clasificación con otros',
    benefit3: 'Gana logros e insignias',
    benefit4: 'Juega multijugador con amigos y familia',
    whySignUp: '¿Por qué registrarse?',
    continuePlaying: 'Continuar Jugando',

    migratingProgress: 'Guardando tu progreso...',
    progressSaved: '¡Tu progreso ha sido guardado!',
    progressMigrationError: 'No se pudo guardar el progreso del invitado',

    guestBadge: 'Invitado',
    signInToSave: 'Inicia sesión para guardar',
    limitedFeatures: 'Funciones Limitadas',
  },
  fr: {
    saveProgressTitle: 'Voulez-vous sauvegarder votre progression?',
    saveProgressSubtitle: 'Inscrivez-vous pour suivre les réalisations, rivaliser sur les classements et débloquer toutes les fonctionnalités',
    saveProgressBenefit1: 'Suivez votre progression dans tous les quiz',
    saveProgressBenefit2: 'Rivalisez sur les classements mondiaux',
    saveProgressBenefit3: 'Débloquez des réalisations et des badges',
    saveProgressBenefit4: 'Jouez en multijoueur avec des amis',
    signUpNow: 'S\'inscrire Maintenant',
    maybeLater: 'Peut-être Plus Tard',

    multiplayerRequiredTitle: 'Connectez-vous pour rejoindre votre famille et vos amis',
    multiplayerRequiredSubtitle: 'Créez un compte pour accéder aux fonctionnalités multijoueur',
    multiplayerRequiredMessage: 'Connectez-vous pour rejoindre votre famille ou vos amis et garder votre progression ensemble.',
    backToSinglePlayer: 'Retour au Solo',

    liveEventsRequiredTitle: 'Connectez-vous pour les Événements en Direct',
    liveEventsRequiredSubtitle: 'Rejoignez des tournois en direct et rivalisez en temps réel',
    liveEventsRequiredMessage: 'Les événements en direct nécessitent un compte pour participer et suivre vos classements.',

    whatYouGet: 'Ce que vous obtiendrez:',

    multiplayerFeature1: 'Jouez des quiz en temps réel avec famille et amis',
    multiplayerFeature2: 'Rivalisez dans des groupes privés et suivez vos classements',
    multiplayerFeature3: 'Défiez les autres et grandissez dans la foi ensemble',

    liveEventsFeature1: 'Rejoignez des tournois mondiaux et gagnez des prix',
    liveEventsFeature2: 'Rivalisez avec des milliers de joueurs du monde entier',
    liveEventsFeature3: 'Suivez vos classements et réalisations en direct',

    signUpButton: 'Créer un Compte Gratuit',
    goBack: 'Pas Maintenant',
    guestProgressNotice: 'Votre progression d\'invité sera sauvegardée lorsque vous vous inscrirez!',

    streakTitle: 'Vous êtes en feu! 🔥',
    streakSubtitle: 'Inscrivez-vous maintenant pour commencer votre série de quiz et ne jamais perdre votre progression',
    streakProgress: '{count} quiz complétés',
    streakBenefit: 'Maintenez votre série de {count} quiz!',

    achievementTitle: 'Excellent Progrès!',
    achievementSubtitle: 'Inscrivez-vous pour sauvegarder vos réalisations et continuer votre parcours',

    benefit1: 'Suivez votre historique et progression des quiz',
    benefit2: 'Rivalisez sur les classements avec d\'autres',
    benefit3: 'Gagnez des réalisations et des badges',
    benefit4: 'Jouez en multijoueur avec amis et famille',
    whySignUp: 'Pourquoi s\'inscrire?',
    continuePlaying: 'Continuer à Jouer',

    migratingProgress: 'Sauvegarde de votre progression...',
    progressSaved: 'Votre progression a été sauvegardée!',
    progressMigrationError: 'Impossible de sauvegarder la progression de l\'invité',

    guestBadge: 'Invité',
    signInToSave: 'Connectez-vous pour sauvegarder',
    limitedFeatures: 'Fonctionnalités Limitées',
  },
  de: {
    saveProgressTitle: 'Möchten Sie Ihren Fortschritt speichern?',
    saveProgressSubtitle: 'Registrieren Sie sich, um Erfolge zu verfolgen, auf Bestenlisten zu konkurrieren und alle Funktionen freizuschalten',
    saveProgressBenefit1: 'Verfolgen Sie Ihren Fortschritt in allen Quiz',
    saveProgressBenefit2: 'Konkurrieren Sie auf globalen Bestenlisten',
    saveProgressBenefit3: 'Schalten Sie Erfolge und Abzeichen frei',
    saveProgressBenefit4: 'Spielen Sie Multiplayer mit Freunden',
    signUpNow: 'Jetzt Registrieren',
    maybeLater: 'Vielleicht Später',

    multiplayerRequiredTitle: 'Melden Sie sich an, um Ihrer Familie und Freunden beizutreten',
    multiplayerRequiredSubtitle: 'Erstellen Sie ein Konto, um auf Multiplayer-Funktionen zuzugreifen',
    multiplayerRequiredMessage: 'Melden Sie sich an, um Ihrer Familie oder Freunden beizutreten und Ihren Fortschritt zusammen zu halten.',
    backToSinglePlayer: 'Zurück zum Einzelspieler',

    liveEventsRequiredTitle: 'Melden Sie sich für Live-Events an',
    liveEventsRequiredSubtitle: 'Nehmen Sie an Live-Turnieren teil und konkurrieren Sie in Echtzeit',
    liveEventsRequiredMessage: 'Live-Events erfordern ein Konto zur Teilnahme und Verfolgung Ihrer Ranglisten.',

    whatYouGet: 'Was Sie erhalten:',

    multiplayerFeature1: 'Spielen Sie Quiz in Echtzeit mit Familie und Freunden',
    multiplayerFeature2: 'Konkurrieren Sie in privaten Gruppen und verfolgen Sie Ihre Ranglisten',
    multiplayerFeature3: 'Fordern Sie andere heraus und wachsen Sie gemeinsam im Glauben',

    liveEventsFeature1: 'Nehmen Sie an globalen Turnieren teil und gewinnen Sie Preise',
    liveEventsFeature2: 'Konkurrieren Sie mit Tausenden Spielern weltweit',
    liveEventsFeature3: 'Verfolgen Sie Ihre Live-Ranglisten und Erfolge',

    signUpButton: 'Kostenloses Konto Erstellen',
    goBack: 'Nicht Jetzt',
    guestProgressNotice: 'Ihr Gast-Fortschritt wird gespeichert, wenn Sie sich anmelden!',

    streakTitle: 'Sie sind auf Hochtouren! 🔥',
    streakSubtitle: 'Registrieren Sie sich jetzt, um Ihre Quiz-Serie zu starten und niemals Ihren Fortschritt zu verlieren',
    streakProgress: '{count} Quiz abgeschlossen',
    streakBenefit: 'Halten Sie Ihre {count}-Quiz-Serie aufrecht!',

    achievementTitle: 'Großartiger Fortschritt!',
    achievementSubtitle: 'Registrieren Sie sich, um Ihre Erfolge zu speichern und Ihre Reise fortzusetzen',

    benefit1: 'Verfolgen Sie Ihre Quiz-Historie und Fortschritt',
    benefit2: 'Konkurrieren Sie auf Bestenlisten mit anderen',
    benefit3: 'Verdienen Sie Erfolge und Abzeichen',
    benefit4: 'Spielen Sie Multiplayer mit Freunden und Familie',
    whySignUp: 'Warum registrieren?',
    continuePlaying: 'Weiterspielen',

    migratingProgress: 'Speichern Sie Ihren Fortschritt...',
    progressSaved: 'Ihr Fortschritt wurde gespeichert!',
    progressMigrationError: 'Gast-Fortschritt konnte nicht gespeichert werden',

    guestBadge: 'Gast',
    signInToSave: 'Anmelden zum Speichern',
    limitedFeatures: 'Eingeschränkte Funktionen',
  },
  pt: {
    saveProgressTitle: 'Quer salvar seu progresso?',
    saveProgressSubtitle: 'Cadastre-se para rastrear conquistas, competir em classificações e desbloquear todos os recursos',
    saveProgressBenefit1: 'Acompanhe seu progresso em todos os questionários',
    saveProgressBenefit2: 'Compita nas classificações globais',
    saveProgressBenefit3: 'Desbloqueie conquistas e emblemas',
    saveProgressBenefit4: 'Jogue multiplayer com amigos',
    signUpNow: 'Cadastrar Agora',
    maybeLater: 'Talvez Mais Tarde',

    multiplayerRequiredTitle: 'Entre para se juntar à sua família e amigos',
    multiplayerRequiredSubtitle: 'Crie uma conta para acessar recursos multiplayer',
    multiplayerRequiredMessage: 'Entre para se juntar à sua família ou amigos e manter seu progresso junto.',
    backToSinglePlayer: 'Voltar para Um Jogador',

    liveEventsRequiredTitle: 'Entre para Eventos ao Vivo',
    liveEventsRequiredSubtitle: 'Participe de torneios ao vivo e compita em tempo real',
    liveEventsRequiredMessage: 'Eventos ao vivo requerem uma conta para participar e rastrear suas classificações.',

    whatYouGet: 'O que você ganhará:',

    multiplayerFeature1: 'Jogue questionários em tempo real com família e amigos',
    multiplayerFeature2: 'Compita em grupos privados e rastreie suas classificações',
    multiplayerFeature3: 'Desafie outros e cresça na fé juntos',

    liveEventsFeature1: 'Participe de torneios globais e ganhe prêmios',
    liveEventsFeature2: 'Compita com milhares de jogadores ao redor do mundo',
    liveEventsFeature3: 'Rastreie suas classificações e conquistas ao vivo',

    signUpButton: 'Criar Conta Grátis',
    goBack: 'Agora Não',
    guestProgressNotice: 'Seu progresso de convidado será salvo quando você se cadastrar!',

    streakTitle: 'Você está em chamas! 🔥',
    streakSubtitle: 'Cadastre-se agora para iniciar sua sequência de questionários e nunca perder seu progresso',
    streakProgress: '{count} questionários completados',
    streakBenefit: 'Mantenha sua sequência de {count} questionários!',

    achievementTitle: 'Ótimo Progresso!',
    achievementSubtitle: 'Cadastre-se para salvar suas conquistas e continuar sua jornada',

    benefit1: 'Acompanhe seu histórico e progresso de questionários',
    benefit2: 'Compita nas classificações com outros',
    benefit3: 'Ganhe conquistas e emblemas',
    benefit4: 'Jogue multiplayer com amigos e família',
    whySignUp: 'Por que se cadastrar?',
    continuePlaying: 'Continuar Jogando',

    migratingProgress: 'Salvando seu progresso...',
    progressSaved: 'Seu progresso foi salvo!',
    progressMigrationError: 'Não foi possível salvar o progresso do convidado',

    guestBadge: 'Convidado',
    signInToSave: 'Entre para salvar',
    limitedFeatures: 'Recursos Limitados',
  },
  ru: {
    saveProgressTitle: 'Хотите сохранить свой прогресс?',
    saveProgressSubtitle: 'Зарегистрируйтесь, чтобы отслеживать достижения, соревноваться в таблицах лидеров и разблокировать все функции',
    saveProgressBenefit1: 'Отслеживайте свой прогресс во всех викторинах',
    saveProgressBenefit2: 'Соревнуйтесь в глобальных таблицах лидеров',
    saveProgressBenefit3: 'Разблокируйте достижения и значки',
    saveProgressBenefit4: 'Играйте в многопользовательском режиме с друзьями',
    signUpNow: 'Зарегистрироваться',
    maybeLater: 'Может Позже',

    multiplayerRequiredTitle: 'Войдите, чтобы присоединиться к семье и друзьям',
    multiplayerRequiredSubtitle: 'Создайте учетную запись для доступа к многопользовательским функциям',
    multiplayerRequiredMessage: 'Войдите, чтобы присоединиться к семье или друзьям и сохранить свой прогресс вместе.',
    backToSinglePlayer: 'Назад к Одиночной Игре',

    liveEventsRequiredTitle: 'Войдите для Живых Событий',
    liveEventsRequiredSubtitle: 'Присоединяйтесь к живым турнирам и соревнуйтесь в реальном времени',
    liveEventsRequiredMessage: 'Живые события требуют учетной записи для участия и отслеживания ваших рейтингов.',

    whatYouGet: 'Что вы получите:',

    multiplayerFeature1: 'Играйте викторины в реальном времени с семьей и друзьями',
    multiplayerFeature2: 'Соревнуйтесь в частных группах и отслеживайте свои рейтинги',
    multiplayerFeature3: 'Бросайте вызов другим и растите в вере вместе',

    liveEventsFeature1: 'Присоединяйтесь к глобальным турнирам и выигрывайте призы',
    liveEventsFeature2: 'Соревнуйтесь с тысячами игроков по всему миру',
    liveEventsFeature3: 'Отслеживайте свои живые рейтинги и достижения',

    signUpButton: 'Создать Бесплатный Аккаунт',
    goBack: 'Не Сейчас',
    guestProgressNotice: 'Ваш гостевой прогресс будет сохранен при регистрации!',

    streakTitle: 'Вы в ударе! 🔥',
    streakSubtitle: 'Зарегистрируйтесь сейчас, чтобы начать свою серию викторин и никогда не терять свой прогресс',
    streakProgress: '{count} викторин завершено',
    streakBenefit: 'Поддерживайте свою серию из {count} викторин!',

    achievementTitle: 'Отличный Прогресс!',
    achievementSubtitle: 'Зарегистрируйтесь, чтобы сохранить свои достижения и продолжить свое путешествие',

    benefit1: 'Отслеживайте историю викторин и прогресс',
    benefit2: 'Соревнуйтесь в таблицах лидеров с другими',
    benefit3: 'Зарабатывайте достижения и значки',
    benefit4: 'Играйте в многопользовательском режиме с друзьями и семьей',
    whySignUp: 'Почему стоит зарегистрироваться?',
    continuePlaying: 'Продолжить Игру',

    migratingProgress: 'Сохранение вашего прогресса...',
    progressSaved: 'Ваш прогресс сохранен!',
    progressMigrationError: 'Не удалось сохранить прогресс гостя',

    guestBadge: 'Гость',
    signInToSave: 'Войдите для сохранения',
    limitedFeatures: 'Ограниченные Функции',
  },
  tl: {
    saveProgressTitle: 'Gusto mo bang i-save ang iyong progress?',
    saveProgressSubtitle: 'Mag-sign up para subaybayan ang mga tagumpay, makipagkompetensya sa mga leaderboard, at i-unlock ang lahat ng feature',
    saveProgressBenefit1: 'Subaybayan ang iyong progress sa lahat ng quiz',
    saveProgressBenefit2: 'Makipagkompetensya sa pandaigdigang leaderboard',
    saveProgressBenefit3: 'I-unlock ang mga tagumpay at badge',
    saveProgressBenefit4: 'Maglaro ng multiplayer kasama ang mga kaibigan',
    signUpNow: 'Mag-sign Up Ngayon',
    maybeLater: 'Siguro Mamaya',

    multiplayerRequiredTitle: 'Mag-sign in para sumali sa iyong pamilya at mga kaibigan',
    multiplayerRequiredSubtitle: 'Gumawa ng account para ma-access ang multiplayer features',
    multiplayerRequiredMessage: 'Mag-sign in para sumali sa iyong pamilya o mga kaibigan at panatilihin ang iyong progreso nang magkasama.',
    backToSinglePlayer: 'Bumalik sa Single Player',

    liveEventsRequiredTitle: 'Mag-sign in para sa Live Events',
    liveEventsRequiredSubtitle: 'Sumali sa live tournaments at makipagkompetensya nang real-time',
    liveEventsRequiredMessage: 'Ang live events ay nangangailangan ng account para makalahok at subaybayan ang iyong ranking.',

    whatYouGet: 'Ano ang makukuha mo:',

    multiplayerFeature1: 'Maglaro ng real-time quiz kasama ang pamilya at kaibigan',
    multiplayerFeature2: 'Makipagkompetensya sa private groups at subaybayan ang iyong ranking',
    multiplayerFeature3: 'Hamunin ang iba at lumaki sa pananampalataya nang sama-sama',

    liveEventsFeature1: 'Sumali sa global tournaments at manalo ng premyo',
    liveEventsFeature2: 'Makipagkompetensya sa libu-libong manlalaro sa buong mundo',
    liveEventsFeature3: 'Subaybayan ang iyong live rankings at mga tagumpay',

    signUpButton: 'Gumawa ng Libreng Account',
    goBack: 'Hindi Ngayon',
    guestProgressNotice: 'Ang iyong guest progress ay ma-save kapag nag-sign up ka!',

    streakTitle: 'Nasa streak ka! 🔥',
    streakSubtitle: 'Mag-sign up ngayon para simulan ang iyong quiz streak at huwag mawalan ng progress',
    streakProgress: '{count} mga quiz na nakumpleto',
    streakBenefit: 'Panatilihin ang iyong {count}-quiz streak!',

    achievementTitle: 'Mahusay na Progreso!',
    achievementSubtitle: 'Mag-sign up para i-save ang iyong mga tagumpay at ipagpatuloy ang iyong paglalakbay',

    benefit1: 'Subaybayan ang iyong kasaysayan at progreso ng quiz',
    benefit2: 'Makipagkompetensya sa leaderboard kasama ng iba',
    benefit3: 'Kamtin ang mga tagumpay at badge',
    benefit4: 'Maglaro ng multiplayer kasama ang mga kaibigan at pamilya',
    whySignUp: 'Bakit mag-sign up?',
    continuePlaying: 'Magpatuloy sa Paglalaro',

    migratingProgress: 'Nag-save ng iyong progress...',
    progressSaved: 'Na-save ang iyong progress!',
    progressMigrationError: 'Hindi ma-save ang guest progress',

    guestBadge: 'Bisita',
    signInToSave: 'Mag-sign in para mag-save',
    limitedFeatures: 'Limitadong Features',
  },
  it: {
    saveProgressTitle: 'Vuoi salvare i tuoi progressi?',
    saveProgressSubtitle: 'Iscriviti per tracciare i risultati, competere nelle classifiche e sbloccare tutte le funzionalità',
    saveProgressBenefit1: 'Traccia i tuoi progressi in tutti i quiz',
    saveProgressBenefit2: 'Competi nelle classifiche globali',
    saveProgressBenefit3: 'Sblocca risultati e distintivi',
    saveProgressBenefit4: 'Gioca multiplayer con gli amici',
    signUpNow: 'Iscriviti Ora',
    maybeLater: 'Forse Più Tardi',

    multiplayerRequiredTitle: 'Accedi per unirti alla tua famiglia e amici',
    multiplayerRequiredSubtitle: 'Crea un account per accedere alle funzionalità multiplayer',
    multiplayerRequiredMessage: 'Accedi per unirti alla tua famiglia o amici e mantenere i tuoi progressi insieme.',
    backToSinglePlayer: 'Torna a Giocatore Singolo',

    liveEventsRequiredTitle: 'Accedi per Eventi dal Vivo',
    liveEventsRequiredSubtitle: 'Partecipa a tornei dal vivo e competi in tempo reale',
    liveEventsRequiredMessage: 'Gli eventi dal vivo richiedono un account per partecipare e tracciare le tue classifiche.',

    whatYouGet: 'Cosa otterrai:',

    multiplayerFeature1: 'Gioca quiz in tempo reale con famiglia e amici',
    multiplayerFeature2: 'Competi in gruppi privati e traccia le tue classifiche',
    multiplayerFeature3: 'Sfida gli altri e cresci nella fede insieme',

    liveEventsFeature1: 'Partecipa a tornei globali e vinci premi',
    liveEventsFeature2: 'Competi con migliaia di giocatori in tutto il mondo',
    liveEventsFeature3: 'Traccia le tue classifiche dal vivo e risultati',

    signUpButton: 'Crea Account Gratuito',
    goBack: 'Non Ora',
    guestProgressNotice: 'I tuoi progressi da ospite verranno salvati quando ti iscrivi!',

    streakTitle: 'Sei in fiamme! 🔥',
    streakSubtitle: 'Iscriviti ora per iniziare la tua serie di quiz e non perdere mai i tuoi progressi',
    streakProgress: '{count} quiz completati',
    streakBenefit: 'Mantieni la tua serie di {count} quiz!',

    achievementTitle: 'Ottimo Progresso!',
    achievementSubtitle: 'Iscriviti per salvare i tuoi risultati e continuare il tuo percorso',

    benefit1: 'Traccia la tua cronologia e i progressi dei quiz',
    benefit2: 'Competi nelle classifiche con altri',
    benefit3: 'Guadagna risultati e distintivi',
    benefit4: 'Gioca multiplayer con amici e famiglia',
    whySignUp: 'Perché iscriversi?',
    continuePlaying: 'Continua a Giocare',

    migratingProgress: 'Salvataggio dei tuoi progressi...',
    progressSaved: 'I tuoi progressi sono stati salvati!',
    progressMigrationError: 'Impossibile salvare i progressi dell\'ospite',

    guestBadge: 'Ospite',
    signInToSave: 'Accedi per salvare',
    limitedFeatures: 'Funzionalità Limitate',
  },
  am: {
    saveProgressTitle: 'እድገትዎን ማስቀመጥ ይፈልጋሉ?',
    saveProgressSubtitle: 'ስኬቶችን ለመከታተል፣ በደረጃ ሰሌዳዎች ላይ ለመወዳደር እና ሁሉንም ባህሪያት ለመክፈት ይመዝገቡ',
    saveProgressBenefit1: 'በሁሉም ጥያቄዎች ላይ እድገትዎን ይከታተሉ',
    saveProgressBenefit2: 'በዓለም አቀፍ ደረጃ ሰሌዳዎች ላይ ይወዳደሩ',
    saveProgressBenefit3: 'ስኬቶችን እና ባጆችን ይክፈቱ',
    saveProgressBenefit4: 'ከጓደኞች ጋር በብዙ ተጫዋቾች ይጫወቱ',
    signUpNow: 'አሁን ይመዝገቡ',
    maybeLater: 'ምናልባት በኋላ',

    multiplayerRequiredTitle: 'ከቤተሰብዎ እና ከጓደኞችዎ ጋር ለመቀላቀል ይግቡ',
    multiplayerRequiredSubtitle: 'የብዙ ተጫዋቾች ባህሪያትን ለማግኘት መለያ ይፍጠሩ',
    multiplayerRequiredMessage: 'ከቤተሰብዎ ወይም ከጓደኞችዎ ጋር ለመቀላቀል እና እድገትዎን አብረው ለመጠበቅ ይግቡ።',
    backToSinglePlayer: 'ወደ ነጠላ ተጫዋች ተመለስ',

    liveEventsRequiredTitle: 'ለቀጥታ ክስተቶች ይግቡ',
    liveEventsRequiredSubtitle: 'በቀጥታ ውድድሮች ላይ ይቀላቀሉ እና በእውነተኛ ጊዜ ይወዳደሩ',
    liveEventsRequiredMessage: 'የቀጥታ ክስተቶች ለመሳተፍ እና ደረጃዎችዎን ለመከታተል መለያ ያስፈልጋቸዋል።',

    whatYouGet: 'ምን ያገኛሉ:',

    multiplayerFeature1: 'ከቤተሰብ እና ከጓደኞች ጋር የእውነተኛ ጊዜ ጥያቄዎችን ይጫወቱ',
    multiplayerFeature2: 'በግል ቡድኖች ውስጥ ይወዳደሩ እና ደረጃዎችዎን ይከታተሉ',
    multiplayerFeature3: 'ሌሎችን ይጠይቁ እና በእምነት አንድ ላይ ያድጉ',

    liveEventsFeature1: 'በዓለም አቀፍ ውድድሮች ላይ ይቀላቀሉ እና ሽልማቶችን ያሸንፉ',
    liveEventsFeature2: 'በዓለም ዙሪያ ካሉ በሺዎች ተጫዋቾች ጋር ይወዳደሩ',
    liveEventsFeature3: 'የቀጥታ ደረጃዎችዎን እና ስኬቶችዎን ይከታተሉ',

    signUpButton: 'ነጻ መለያ ይፍጠሩ',
    goBack: 'አሁን አይደለም',
    guestProgressNotice: 'ሲመዘገቡ የእንግዳ እድገትዎ ይቀመጣል!',

    streakTitle: 'እርስዎ በእሳት ላይ ናችሁ! 🔥',
    streakSubtitle: 'የእርስዎን የጥያቄ ተከታታይ ለመጀመር እና እድገትዎን በፍጹም ላለማጣት አሁን ይመዝገቡ',
    streakProgress: '{count} ጥያቄዎች ተጠናቀቁ',
    streakBenefit: 'የእርስዎን {count}-ጥያቄ ተከታታይ ይያዙ!',

    achievementTitle: 'ድንቅ እድገት!',
    achievementSubtitle: 'ስኬቶችዎን ለማስቀመጥ እና ጉዞዎን ለመቀጠል ይመዝገቡ',

    benefit1: 'የእርስዎን የጥያቄ ታሪክ እና እድገት ይከታተሉ',
    benefit2: 'ከሌሎች ጋር በደረጃ ሰሌዳዎች ላይ ይወዳደሩ',
    benefit3: 'ስኬቶችን እና ባጆችን ያግኙ',
    benefit4: 'ከጓደኞች እና ከቤተሰብ ጋር በብዙ ተጫዋቾች ይጫወቱ',
    whySignUp: 'ለምን መመዝገብ?',
    continuePlaying: 'ማጫወትን ይቀጥሉ',

    migratingProgress: 'እድገትዎን በማስቀመጥ ላይ...',
    progressSaved: 'እድገትዎ ተስቷል!',
    progressMigrationError: 'የእንግዳ እድገት ማስቀመጥ አልተቻለም',

    guestBadge: 'እንግዳ',
    signInToSave: 'ለማስቀመጥ ይግቡ',
    limitedFeatures: 'የተወሰኑ ባህሪያት',
  },
  ko: {
    saveProgressTitle: '진행 상황을 저장하시겠습니까?',
    saveProgressSubtitle: '가입하여 업적을 추적하고, 리더보드에서 경쟁하며, 모든 기능을 잠금 해제하세요',
    saveProgressBenefit1: '모든 퀴즈에서 진행 상황 추적',
    saveProgressBenefit2: '글로벌 리더보드에서 경쟁',
    saveProgressBenefit3: '업적 및 배지 잠금 해제',
    saveProgressBenefit4: '친구와 멀티플레이어 플레이',
    signUpNow: '지금 가입',
    maybeLater: '나중에',

    multiplayerRequiredTitle: '가족과 친구에 참여하려면 로그인',
    multiplayerRequiredSubtitle: '멀티플레이어 기능에 액세스하려면 계정 만들기',
    multiplayerRequiredMessage: '가족이나 친구에 참여하고 진행 상황을 함께 유지하려면 로그인하세요.',
    backToSinglePlayer: '싱글 플레이어로 돌아가기',

    liveEventsRequiredTitle: '라이브 이벤트에 로그인',
    liveEventsRequiredSubtitle: '라이브 토너먼트에 참여하고 실시간으로 경쟁',
    liveEventsRequiredMessage: '라이브 이벤트는 참여하고 순위를 추적하려면 계정이 필요합니다.',

    whatYouGet: '얻을 수 있는 것:',

    multiplayerFeature1: '가족 및 친구와 실시간 퀴즈 플레이',
    multiplayerFeature2: '비공개 그룹에서 경쟁하고 순위 추적',
    multiplayerFeature3: '다른 사람에게 도전하고 함께 믿음 성장',

    liveEventsFeature1: '글로벌 토너먼트에 참여하고 상품 획득',
    liveEventsFeature2: '전 세계 수천 명의 플레이어와 경쟁',
    liveEventsFeature3: '라이브 순위 및 업적 추적',

    signUpButton: '무료 계정 만들기',
    goBack: '나중에',
    guestProgressNotice: '가입하면 게스트 진행 상황이 저장됩니다!',

    streakTitle: '당신은 불타고 있습니다! 🔥',
    streakSubtitle: '지금 가입하여 퀴즈 연속 기록을 시작하고 진행 상황을 절대 잃지 마세요',
    streakProgress: '{count}개 퀴즈 완료',
    streakBenefit: '{count}-퀴즈 연속 기록을 유지하세요!',

    achievementTitle: '훌륭한 진행!',
    achievementSubtitle: '가입하여 업적을 저장하고 여정을 계속하세요',

    benefit1: '퀴즈 기록 및 진행 상황 추적',
    benefit2: '다른 사람과 리더보드에서 경쟁',
    benefit3: '업적 및 배지 획득',
    benefit4: '친구 및 가족과 멀티플레이어 플레이',
    whySignUp: '왜 가입해야 하나요?',
    continuePlaying: '계속 플레이',

    migratingProgress: '진행 상황 저장 중...',
    progressSaved: '진행 상황이 저장되었습니다!',
    progressMigrationError: '게스트 진행 상황을 저장할 수 없습니다',

    guestBadge: '게스트',
    signInToSave: '저장하려면 로그인',
    limitedFeatures: '제한된 기능',
  },
};
